import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, Renderer2 } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class ScriptLoaderService {
    constructor(@Inject(DOCUMENT) private readonly document: Document) {}

    /**
     * Append the JS tag to the Document Body.
     * @param renderer The Angular Renderer
     * @param src The path to the script
     * @returns the script element
     */
    public loadJsScript(renderer: Renderer2, src: string): HTMLScriptElement {
        const script = renderer.createElement('script');
        script.type = 'text/javascript';
        script.defer = true;
        script.async = true;
        script.src = src;
        renderer.appendChild(this.document.head, script);
        return script;
    }

    public removeJsScript(renderer: Renderer2, src: string): void {
        const script = this.document.querySelector(`script[src="${src}"]`);
        if (script) {
            renderer.removeChild(this.document.head, script);
        }
    }
}
